import React from 'react';
import {notificationCategory} from "../../../../common/config-variable/notification";
import {DoNotify} from '@dogoo/do-notifications'
import {useMainAppContext} from '../../../../hooks/useMainAppContext'
import {
    deleteActionNotification,
    getActionNotification,
    getAllButtonProcessInNotify,
    postActionNotification,
    putActionNotification,
    updateSeenAllNotificationByReceiverId,
    updateStatusAllNotificationByReceiverId,
    updateStatusNotification
} from '../../../../api/common/layout/notification'
import {getMe} from '../../../../api/system/admin/user-account'

function HeaderNotify(props) {
    // const dispatch = useDispatch()

    const { allNotifications, refetchAllNotification, notificationCount, setNotificationCount } =
        useMainAppContext()

    // const {reloadDataButtonProcess} = useSelector(state => state.layoutInteractionReducer)
    //
    // const onClickButton = (value) => {
    //     dispatch(changeDataButtonProcess(value))
    // }

    const changeNotifyStatus = (id, type) => {
        if (type === 'read') {
            updateStatusNotification(id, { status: 'read' }).then(r => {
                setNotificationCount(notificationCount > 1 ? notificationCount - 1 : 0)
            })
        } else {
            updateStatusAllNotificationByReceiverId(getMe().userId, { status: 'read' }).then(r => {
                setNotificationCount(0)
            })
        }
    }

    const getActionButton = (method, actionUrl, payload, config) => {
        switch (method) {
            case 'get':
                return getActionNotification(actionUrl, config)
            case 'put':
                return putActionNotification(actionUrl, payload, config)
            case 'post':
                return postActionNotification(actionUrl, payload, config)
            case 'delete':
                return deleteActionNotification(actionUrl, config)
            default:
                return postActionNotification(actionUrl, payload, config)
        }
    }

    const handleButtonAction = (method, actionUrl, payload, config) => {
        getActionButton(method, actionUrl, payload, config).then(() => {
            // changeNotifyStatus(payload, 'read')
            refetchAllNotification({ page: 1 })
        }).catch((e) => {
            console.log('error', e)
        })
    }

    const handleSeenAll = async () => {
        await updateSeenAllNotificationByReceiverId(getMe().userId, {
            seen: true
        }).then(() => {
            setNotificationCount(0)
        })
    }

    return (
        <>
            {/*<NotificationComponent*/}
            {/*    axios={DG_axiosNormal}*/}
            {/*    firebaseConfig={firebaseConfig}*/}
            {/*    notificationCategory={notificationCategory}*/}
            {/*    notificationCategoryUpdate={notificationCategory}*/}
            {/*    onClickButton={onClickButton}*/}
            {/*    reloadDataButtonProcess={reloadDataButtonProcess}*/}
            {/*/>*/}
            <DoNotify
                data={allNotifications}
                refetch={refetchAllNotification}
                changeStatus={changeNotifyStatus}
                category={notificationCategory}
                getButtonProcess={(value) => getAllButtonProcessInNotify(value)}
                buttonAction={handleButtonAction}
                noRead={notificationCount}
                handleSeenAll={handleSeenAll}
            />
        </>
    );
}

export default HeaderNotify;